import React from 'react';
import { FadeIn } from './FadeIn';
import { Coffee } from 'lucide-react';
export function Section4() {
  return <section className="py-24 px-6 bg-ivory" data-id="element-183">
      <div className="max-w-3xl mx-auto text-center" data-id="element-184">
        <FadeIn data-id="element-185">
          <h2 className="text-3xl md:text-5xl font-bold text-dark mb-12" data-id="element-186">
            ¿POR QUÉ SOLO $16?
          </h2>
        </FadeIn>

        <div className="space-y-8 text-lg text-dark-light leading-relaxed" data-id="element-187">
          <FadeIn delay={0.2} data-id="element-188">
            <p className="font-serif text-2xl text-gold-dark italic" data-id="element-189">
              Esta es la pregunta que más me hacen.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-190">
            <p data-id="element-191">
              La respuesta es simple: el problema del crédito en nuestra
              comunidad no es de voluntad. Es de acceso a la información
              correcta. Si cobro $500, solo llego a 100 personas. Si cobro $16,
              llego a 10,000 familias que pueden comprar su primera casa este
              año.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-192">
            <div className="py-8 flex flex-col items-center justify-center gap-4" data-id="element-193">
              <Coffee size={48} className="text-gold" data-id="element-194" />
              <p className="text-2xl font-bold text-dark" data-id="element-195">
                $16 es el precio de dos cafés con leche en Starbucks.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-196">
            <p className="font-medium text-xl text-dark" data-id="element-197">
              La diferencia es que los cafés te duran 20 minutos y este manual
              puede ahorrarte{' '}
              <span className="text-gold-dark font-bold" data-id="element-198">
                $40,000 en intereses
              </span>{' '}
              durante la vida de tu hipoteca.
            </p>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-199">
            <p className="text-sm uppercase tracking-widest text-dark-light/70 mt-8" data-id="element-200">
              No hay trampa. No hay letra pequeña. Es un archivo PDF que
              descargas en 30 segundos y empiezas a leer hoy mismo.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}